/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  message,
  Select,
  Form,
} from 'antd';

import { updateAssignedRecord } from '../../actions/records';

import ModalWrapper from './ModalWrapper';
import DebounceSelect from './DebounceSelect';
import { fetchAssigneeOptions } from './assigneeSearch';

export class UpdateAssignedDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDocumentStatus: this.props.modalType.data.selectedDocumentStatus,
      documentStatuses: [],
      assignedDocId: this.props.modalType.data.assignedDocumentId,
      assignee: this.props.modalType.data.assignee,
    };
  }

  componentDidMount = async () => {
    const { getDocumentStatuses } = this.props;
    await getDocumentStatuses();
    this.setState({ documentStatuses: this.props.allDocumentStatuses.document_statuses });
  }

  update = async (event) => {
    event.preventDefault();
    const {
      assignedDocId,
      selectedDocumentStatus,
      assignee,
    } = this.state;
    const reassigned = assignee.value !== this.props.modalType.data.assignee.value;
    if (reassigned && this.props.modalType.data.canReassign === false) return;
    await this.props.updateAssignedRecord(assignedDocId, selectedDocumentStatus, reassigned ? assignee.value : undefined);
    const { updatedStatus, hideModal } = this.props;
    if (updatedStatus) {
      hideModal();
      window.location.reload();
      message.success({
        content: 'Assigned document successfully updated',
      });
    }
  }

  handleChange = (value) => {
    this.setState({ selectedDocumentStatus: value });
  }

  // `e` is the picked option itself ({ value: email, label: name }), so it is right
  // even when the picker's responses arrived out of order.
  handleAssignToChange = (e) => {
    this.setState({ assignee: { value: e.value, label: e.label } });
  };

  fetchUserList = (value) => {
    const { searchAssignableUsers } = this.props;
    return fetchAssigneeOptions({ value, searchAssignableUsers });
  }

  render() {
    const { isLoading, hideModal } = this.props;
    const {
      documentStatuses, selectedDocumentStatus, assignee,
    } = this.state;
    const customContentStyle = {
      width: '340px',
    };

    return (
      <ModalWrapper
        hideModal={hideModal}
        customContentStyle={customContentStyle}
        action={this.update}
        actionName="Submit"
        dismiss={isLoading ? '' : 'Cancel'}
        disabled={isLoading}
        modalTitle="Update Assigned Document"
        form="updateAssignedDocument"
      >
        <Form
          layout="vertical"
          onFinish={this.update}
          id="updateAssignedDocument"
        >
          <div style={{ display: 'flex', gap: '10px' }}>
            <Form.Item
              label="Document Status"
              style={{ flex: 0.5 }}
            >
              <Select
                style={{ width: '220px' }}
                placeholder="Select Document Status"
                onChange={this.handleChange}
                value={selectedDocumentStatus}
              >
                {documentStatuses.map(docStatus => <Select.Option key={docStatus.id} value={docStatus.id}>{docStatus.name}</Select.Option>)}
              </Select>
            </Form.Item>

            <Form.Item
              name="Assigned_to"
              label="Assigned Medsender User:"
              style={{ flex: 0.5 }}
            >
              <></>
              <DebounceSelect
                disabled={this.props.modalType.data.canReassign === false}
                showSearch
                value={assignee}
                placeholder="Search for Medsender users"
                fetchOptions={this.fetchUserList}
                onChange={this.handleAssignToChange}
              />
            </Form.Item>
          </div>
        </Form>
      </ModalWrapper>
    );
  }
}

UpdateAssignedDocument.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modalType: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  allDocumentStatuses: PropTypes.object.isRequired,
  getDocumentStatuses: PropTypes.func.isRequired,
  updatedStatus: PropTypes.bool.isRequired,
  updateAssignedRecord: PropTypes.func.isRequired,
  searchAssignableUsers: PropTypes.func.isRequired,
};

export default connect(state => ({
  isLoading: state.records.isLoading,
  emailValidMessage: state.records.emailValidMessage,
  updatedStatus: state.records.updatedStatus,
  data: state.labels.data,
  allDocumentStatuses: state.userProfile.allDocumentStatuses,
}), {
  updateAssignedRecord,
})(UpdateAssignedDocument);
